<template>
  <div class="card mb-3">
    <div class="card-header text-white bg-secondary">
      Order Items to pick
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Product</th>
          <th width="20%">Model</th>
          <th width="10%">Quantity</th>
          <th width="10%">Scanned</th>
        </tr>
      </thead>
      <tbody>
        <tr
          :key="index"
          v-for="(item, index) in order.items"
          :class="{
            'bg-warning  text-white':
              item.scanCount < item.quantity && item.scanCount > 0,
            'bg-success  text-white': item.scanCount == item.quantity,
            'bg-danger  text-white': item.scanCount > item.quantity,
            'red-qty': item.quantity > 1
          }"
        >
          <td>{{ item.name }}</td>
          <td>{{ item.model }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.scanCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "shopify-order-details",
  props: ["order"],
  data() {
    return {};
  }
};
</script>
